exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue[data-v-552c3b0d]{color:#335dc9;cursor:pointer}", ""]);

// exports
